import { useRenderer } from '@fox/atoms/hooks/use-renderer';
import { IBlockProps } from '@fox/blocks/contracts/block';
import { useSubscribeTopicWithHandler } from '@fox/extensions/src/extension-hooks';
import { useI18n } from '@fox/extensions/src/use-i18n';
import { useState } from 'react';
import { RSVP_YES_BLOCK_TYPE } from '../../../../form-block-types';
import { EventCapacityStatus } from '../../../form-event-context/contracts';
import { useFormEventContext } from '../../../form-event-context/form-event-context';
import { FORM_QUESTION_ANSWERED_TOPIC, FormRenderMode } from '../../../form-runtime-context/contracts';
import { useFormRuntimeContext } from '../../../form-runtime-context/form-runtime-context';
import { FormButtonWrapper } from '../../../styled/form-button-wrapper';
import { ButtonBlock } from '../../button-block/button-block';
import { ButtonBlockProps } from '../../button-block/contracts';
import { checkAllowNext } from '../../form-block/util/allow-next';
import { ensureAnswers } from '../../form-block/util/ensure-answers';

function RSVPYesBlock({ id, props, type }: IBlockProps<ButtonBlockProps>) {
	const { submitForm, getAnswers, formRenderMode, layout, sections, currentPage: formCurrentPage } = useFormRuntimeContext();
	const [loading, setLoading] = useState(false);
	const eventContext = useFormEventContext();
	const render = useRenderer();
	useSubscribeTopicWithHandler(FORM_QUESTION_ANSWERED_TOPIC, () => {
		render();
	});
	const i18n = useI18n();
	const onWaitList = eventContext?.event?.status === EventCapacityStatus.OnWaitlist;
	const currentPage = sections[formCurrentPage ?? 0];
	const allowNext = checkAllowNext({ formRenderMode, currentPage, waitlistSubmit: onWaitList, layout, sections, getAnswers });

	return (
		<FormButtonWrapper $disabled={(!allowNext || loading) && formRenderMode !== FormRenderMode.design} id="rsvpbutton">
			<ButtonBlock
				id={id}
				type={type}
				props={props}
				onClick={async e => {
					e.preventDefault();
					const answers = getAnswers();
					setLoading(true);
					if (formRenderMode === FormRenderMode.design || !allowNext || loading) {
						return;
					}
					const answer = {
						questionName: 'Rsvp',
						answer: {
							answerBoolean: true
						}
					};
					const toSubmit = await ensureAnswers(answers ? [...answers, answer] : [answer], i18n.countryCode);
					await submitForm?.(toSubmit);
					setLoading(false);
				}}
			/>
		</FormButtonWrapper>
	);
}
/**
 * @deprecated
 * Legacy runtime registration for the RSVP "Yes" button block.
 *
 * This block is retained for backward compatibility with older forms that may still reference it.
 * It cannot be added to forms anymore.
 * Use RSVP_BLOCK_TYPE instead.
 */
export const RSVPYesBlockRuntime = {
	type: RSVP_YES_BLOCK_TYPE,
	Component: RSVPYesBlock
};
